module.exports = __webpack_public_path__ + "static/media/intro.59e0e04a.mp3";